import * as React from 'react';

// The frame every section of a stage panel shares: one title style and one
// spacing, so the sections of the Opening, Middlegame and Ending tabs read
// alike whichever plugin draws them. A section plugin renders its body inside
// this frame through the `review.stageSection` extension and draws no title
// or outer margin of its own. A frame whose body renders nothing is hidden
// (see stage-section.css), so a title never sits over empty space.

export interface StageSectionProps {
  /** The section's title, e.g. "Blunders and misses"; omitted for an untitled section such as the book line. */
  title?: string;
  /** Muted text after the title, e.g. "Scanning 2 of 5". */
  aside?: string;
  /** Tooltip on the title. */
  tooltip?: string;
  children?: React.ReactNode;
}

export const StageSection: React.FC<StageSectionProps> = ({ title, aside, tooltip, children }) => (
  <section className="stage-section">
    {title && (
      <h3 className="section-title stage-section-title" title={tooltip}>
        {title}
        {aside && <span className="stage-section-aside"> · {aside}</span>}
      </h3>
    )}
    <div className="stage-section-body">{children}</div>
  </section>
);
